import onChange from './onChange';
import logValue from './logValue';
import store from '../../../reducers/storeRegistration';
const logValueOnChange = (state, props) => async changes => {
  const operationPending = props.operationPending,
    operationComplete = props.operationComplete;
  await operationPending();
  let newState = store.getState();
  const onChangeFunc = onChange(newState, props);
  // Dispatch the original change event, untouched.
  // propagate change.
  await onChangeFunc(changes);
  newState = store.getState();
  const logChange = JSON.parse(JSON.stringify(changes));
  delete logChange.path;
  delete logChange.changeModifiers;
  await logValue(state, props)(logChange);
  operationComplete();
};
export default logValueOnChange;